module.exports = __webpack_public_path__ + "static/media/intro.44e03e4.webm";


//////////////////
// WEBPACK FOOTER
// ./static/video/intro.webm
// module id = Z71U
// module chunks = 1